import type { ApiGetTemplateListResponse } from "@/api/ApiGetTemplateList";
import { canv } from "@/canv/global";
import { logException } from "@/canv/utils";
import type { Group } from "@/group";
import { selectionManager } from "@/tools/cursorTool";

export const ApiGetTemplateByName = async (
    templateName: string,
): Promise<ApiGetTemplateListResponse | undefined> => {
    let result: Response;
    try {
        result = await fetch(`${canv.host}/api/v2/template/get?templateName=${templateName}`, {
            method: "GET",
        });

        if (!result.ok) {
            logException(new Error("HTTP /api/v2/template/get?templateName='templateName' fail"));
            return;
        }
    } catch (err: any) {
        logException(err);
        return;
    }

    const jsonRes = await result.json();
    let newGroups: Group[];
    try {
        newGroups = (await canv.canvasController.loadFlatEnitites(jsonRes.data, true)) as Group[];
    } catch (err: any) {
        logException(err);
        return;
    }

    canv.eventManager.openRecord();

    const oldProps = canv.canvasController.getSelectedProps(canv.canvasController.items);
    const templateProps = canv.canvasController.getSelectedProps(newGroups);

    const rightGap = canv.actionManager.getConstant(500);
    for (let i = 0; i < newGroups.length; i++) {
        newGroups[i].translateGroup(
            oldProps.startX + oldProps.width - templateProps.startX + rightGap,
            oldProps.startY - templateProps.startY,
        );
        canv.eventManager.createBuildEvent("create", newGroups[i]);
    }

    selectionManager.setSelected(newGroups);
    canv.zoomToSelected();

    canv.eventManager.closeRecord();
    canv.redraw();
};
